import { combineReducers } from 'redux';
import adAgree from './adAgree';
import policyAgree from './policyAgree';

export default combineReducers({
  adAgree,
  policyAgree,
});
